<div class="flex items-start">
  <label class="flex items-center" [ngClass]="getRadioClasses()" [for]="htmlId">
    <input type="radio" name="radio_{{ groupId }}" [id]="htmlId" [value]="key" [checked]="isChecked()" (change)="onChange($event)" class="form-radio border-input-outline" />
    <span class="pl-2 pr-1 text-base">{{ label | translate }}</span>
  </label>
</div>
